import { atom, selector } from "recoil";

export const categoriesState = atom({
    key: "categories",
    default: [],
  });

  export const getCategories = selector({
    key: "getCategories",
    get: ({ get }) => {
      const categoryList = get(categoriesState);
      return categoryList;
    },
  });